// @ngInject
common_module.constant('AppStates', {

});
common_module.config(["AppStates", function (AppStates) {

    AppStates.root = 'root';
    AppStates.root_core = AppStates.root + '.core';

    AppStates.root_core_oneFlow = AppStates.root_core + '.oneFlow';
    AppStates.root_core_oneFlowEdit = AppStates.root_core_oneFlow + '.edit';
    AppStates.root_core_onboardingGuidance = AppStates.root_core + '.onboardingGuidance';
    AppStates.root_core_onboardingMobileGuide = AppStates.root_core + '.onboardingMobileGuide';
    AppStates.root_core_onboardingMobileGuideStep = AppStates.root_core + '.onboardingMobileGuideStep';
    AppStates.root_core_onboardingMobileQuiz = AppStates.root_core + '.onboardingMobileQuiz';
    AppStates.root_core_onboardingQuiz = AppStates.root_core + '.onboardingQuiz';

    AppStates.root_core_onboardingInvoiceV2CreationStart = AppStates.root_core + '.onboardingInvoiceV2Start';
    AppStates.root_core_onboardingInvoiceV2CreationBrand = AppStates.root_core + '.onboardingInvoiceV2Brand';
    AppStates.root_core_onboardingInvoiceV2CreationPackage = AppStates.root_core + '.onboardingInvoiceV2Package';

    AppStates.root_core_onboardingInvoiceCreationStart = AppStates.root_core + '.onboardingInvoiceStart';
    AppStates.root_core_onboardingInvoiceCreationBrand = AppStates.root_core + '.onboardingInvoiceBrand';
    AppStates.root_core_onboardingInvoiceCreationPackage = AppStates.root_core + '.onboardingInvoicePackage';
    AppStates.root_core_onboardingInvoiceCreationEmail = AppStates.root_core + '.onboardingInvoiceEmail';
    AppStates.root_core_navigation = AppStates.root_core + '.navigation';
    AppStates.root_core_navigation_dashboard = AppStates.root_core_navigation + '.dashboard';
    AppStates.root_core_navigation_pipeline = AppStates.root_core_navigation + '.pipeline';
    AppStates.root_core_navigation_home = AppStates.root_core_navigation + '.home';
    AppStates.root_core_navigation_native = AppStates.root_core_navigation + '.native';

    AppStates.root_core_navigation_calendarAbstract = AppStates.root_core_navigation + '.calendarAbstract';
    AppStates.root_core_navigation_calendar = AppStates.root_core_navigation_calendarAbstract + '.calendar';
    AppStates.root_core_navigation_scheduling = AppStates.root_core_navigation_calendarAbstract + '.scheduling';
    AppStates.root_core_sessionConfig = AppStates.root_core + '.sessionConfig';

    AppStates.root_core_navigation_batch_email = AppStates.root_core_navigation + '.batchEmails';
    AppStates.root_core_navigation_bulk_workspace_email = AppStates.root_core_navigation + '.bulkWorkspaceEmails';

    AppStates.root_core_navigation_workflows = AppStates.root_core_navigation + '.workflows';
    AppStates.root_core_navigation_workflow_setup = AppStates.root_core_navigation + '.workflowSetup';
    AppStates.root_core_navigation_files = AppStates.root_core_navigation + '.workspace_files';
    AppStates.root_core_navigation_client = AppStates.root_core_navigation + '.client_navigation';
    AppStates.root_core_navigation_contacts = AppStates.root_core_navigation + '.contacts';
    AppStates.root_core_navigation_my_connections = AppStates.root_core_navigation + '.my_connections';
    AppStates.root_core_navigation_tools_mobile = AppStates.root_core_navigation + '.tools';
    AppStates.root_core_navigation_business_tools = AppStates.root_core_navigation + '.business_tools';
    AppStates.root_core_navigation_dashboard_workspace_cards = AppStates.root_core_navigation_dashboard + '.workspaceCards';
    AppStates.root_core_navigation_activity_notifications = AppStates.root_core_navigation + '.activity_notifications';
    AppStates.root_core_navigation_invite = AppStates.root_core_navigation + '.invite';
    AppStates.root_core_navigation_invite_tabs_mobile = AppStates.root_core_navigation_invite + '.mobile';
    AppStates.root_core_navigation_invite_referrals = AppStates.root_core_navigation_invite + '.referrals';
    AppStates.root_core_navigation_invite_partners = AppStates.root_core_navigation_invite + '.partners';
    AppStates.root_core_navigation_invite_track = AppStates.root_core_navigation_invite + '.track';
//    AppStates.root_core_navigation_dashboard_workspace_files = AppStates.root_core_navigation_dashboard + '.workspaceFiles';
//    AppStates.root_core_navigation_dashboard_contacts = AppStates.root_core_navigation_dashboard + '.contacts';
    AppStates.root_core_navigation_onboarding = AppStates.root_core_navigation + '.onboarding';
    AppStates.root_core_navigation_event_wrapper = AppStates.root_core_navigation + '.event_wrapper';
    AppStates.root_core_navigation_event = AppStates.root_core_navigation_event_wrapper + '.event';
    AppStates.root_core_navigation_emptyEvent = AppStates.root_core_navigation + '.emptyEvent';
    AppStates.root_core_navigation_event_overview = AppStates.root_core_navigation_event + '.overview';
    AppStates.root_core_navigation_event_workspace = AppStates.root_core_navigation_event + '.workspace';
    AppStates.root_core_navigation_event_workspace_files = AppStates.root_core_navigation_event_workspace + '.workspace_files';
    AppStates.root_core_navigation_event_workspace_payments = AppStates.root_core_navigation_event_workspace + '.payments';
    AppStates.root_core_navigation_event_workspace_details = AppStates.root_core_navigation_event_workspace + '.details';
    AppStates.root_core_navigation_event_workspace_feed = AppStates.root_core_navigation_event_workspace + '.feed';
    AppStates.root_core_navigation_event_workspace_tasks = AppStates.root_core_navigation_event_workspace + '.tasks';
    AppStates.root_core_navigation_tasks = AppStates.root_core_navigation + '.tasks';
    AppStates.root_core_navigation_corona = AppStates.root_core_navigation + '.corona';
    AppStates.root_core_navigation_time_tracker = AppStates.root_core_navigation + '.time_tracker';
    AppStates.root_core_navigation_facebook_leads = AppStates.root_core_navigation + '.facebook_leads';

    AppStates.root_core_navigation_reports = AppStates.root_core_navigation + '.reports';
    AppStates.root_core_navigation_reports_analytics = AppStates.root_core_navigation_reports + '.analytics';
    AppStates.root_core_navigation_profit_loss = AppStates.root_core_navigation_reports + '.profit_loss';
    AppStates.root_core_navigation_reports_payments = AppStates.root_core_navigation_reports + '.payments';
    AppStates.root_core_navigation_reports_fees = AppStates.root_core_navigation_reports + '.fees';
    AppStates.root_core_navigation_reports_referrals = AppStates.root_core_navigation_reports + '.referrals';

    AppStates.root_core_navigation_expenses = AppStates.root_core_navigation + '.expenses';
    AppStates.root_core_navigation_loans = AppStates.root_core_navigation + '.loans';
    AppStates.root_core_navigation_track = AppStates.root_core_navigation + '.track';
    AppStates.root_core_navigation_cashflow = AppStates.root_core_navigation + '.cashflow';
    AppStates.root_core_navigation_bank_account_data = AppStates.root_core_navigation + '.bank_account_data';

    AppStates.root_core_navigation_settings = AppStates.root_core_navigation + '.settings';
    AppStates.root_core_navigation_create_new = AppStates.root_core_navigation + '.createNew';
    AppStates.root_core_navigation_settings_account = AppStates.root_core_navigation_settings + '.account';
    AppStates.root_core_navigation_settings_companySettings = AppStates.root_core_navigation_settings + '.companySettings';
    // AppStates.root_core_navigation_settings_companySettings_overview = AppStates.root_core_navigation_settings_companySettings + '.overview';
    AppStates.root_core_navigation_settings_companySettings_library = AppStates.root_core_navigation_settings_companySettings + '.library';
    AppStates.root_core_navigation_settings_companySettings_widget = AppStates.root_core_navigation_settings_companySettings + '.widget';
    // AppStates.root_core_navigation_settings_companySettings_bankInfo = AppStates.root_core_navigation_settings_companySettings + '.bankInfo';
    AppStates.root_core_navigation_settings_companySettings_automation = AppStates.root_core_navigation_settings_companySettings + '.automation';
    AppStates.root_core_navigation_settings_companySettings_quickbooks = AppStates.root_core_navigation_settings_companySettings + '.quickbooks';
    AppStates.root_core_navigation_settings_companySettings_setup = AppStates.root_core_navigation_settings_companySettings + '.setup';
    // AppStates.root_core_navigation_settings_companySettings_team = AppStates.root_core_navigation_settings_companySettings + '.team';
    AppStates.root_core_navigation_settings_companySettings_referrals = AppStates.root_core_navigation_settings_companySettings + '.referrals';
    // AppStates.root_core_navigation_settings_companySettings_subscription = AppStates.root_core_navigation_settings_companySettings + '.subscription';
    AppStates.root_core_navigation_settings_companySettings_new_general = AppStates.root_core_navigation_settings_companySettings + '.general';

    // NEW COMPANY SETTINGS
    AppStates.root_core_navigation_settings_company = AppStates.root_core_navigation_settings + '.company';
    AppStates.root_core_navigation_settings_mobile = AppStates.root_core_navigation_settings + '.mobile';
    AppStates.root_core_navigation_settings_company_general = AppStates.root_core_navigation_settings_company + '.general';
    AppStates.root_core_navigation_settings_company_integrations = AppStates.root_core_navigation_settings_company + '.integrations';
    AppStates.root_core_navigation_settings_company_branding = AppStates.root_core_navigation_settings_company + '.branding';
    AppStates.root_core_navigation_settings_company_client_portal = AppStates.root_core_navigation_settings_company + '.clientPortal';
    AppStates.root_core_navigation_settings_company_team = AppStates.root_core_navigation_settings_company + '.team';
    AppStates.root_core_navigation_settings_company_subscription = AppStates.root_core_navigation_settings_company + '.subscription';
    AppStates.root_core_navigation_settings_company_bankInfo = AppStates.root_core_navigation_settings_company + '.bankInfo';
    AppStates.root_core_navigation_settings_company_mobile = AppStates.root_core_navigation_settings_company + '.mobile';
    AppStates.root_core_navigation_settings_company_preferences = AppStates.root_core_navigation_settings_company + '.notifications';
    // For backwards compatibility (Needs to be removed)
    AppStates.root_core_navigation_settings_companySettings_overview = AppStates.root_core_navigation_settings_company_general;
    AppStates.root_core_navigation_settings_companySettings_bankInfo = AppStates.root_core_navigation_settings_company_bankInfo;
    AppStates.root_core_navigation_settings_companySettings_team = AppStates.root_core_navigation_settings_company_team;
    AppStates.root_core_navigation_settings_companySettings_subscription = AppStates.root_core_navigation_settings_company_subscription;
    // END

    AppStates.root_core_navigation_settings_company_client_portal_preview = AppStates.root_core + '.clientPortalPreview';


    AppStates.root_core_navigation_templates = AppStates.root_core_navigation + '.templates';
    AppStates.root_core_navigation_templatesEditor = AppStates.root_core_navigation + '.templatesEditor';

    AppStates.root_core_workspaceFile = AppStates.root_core + '.workspaceFile';
    AppStates.root_core_workspaceFileRedirection = AppStates.root_core + '.workspaceFileRedirection';
    AppStates.root_core_workspaceFile_stepProposal = AppStates.root_core + '.workspaceFileStepProposal';
    AppStates.root_core_workspaceFile_stepAgreement = AppStates.root_core + '.workspaceFileStepAgreement';
    AppStates.root_core_workspaceFile_stepPayment = AppStates.root_core + '.workspaceFileStepPayment';
    AppStates.root_core_workspaceFile_stepQuestionnaire = AppStates.root_core + '.workspaceFileStepQuestionnaire';
    AppStates.root_core_workspaceFile_brochure = AppStates.root_core + '.workspaceFileBrochure';
    AppStates.root_core_workspaceFile_timeline = AppStates.root_core + '.workspaceFileTimeline';
    AppStates.root_core_login = AppStates.root_core + '.login';
    AppStates.root_core_signup = AppStates.root_core + '.signup';
    AppStates.root_core_accountSetup = AppStates.root_core + '.account_setup';
    AppStates.root_core_pay = AppStates.root_core + '.pay';

    AppStates.root_core_linkExpired = AppStates.root_core + '.linkExpired';
    AppStates.root_core_clientLogin = AppStates.root_core + '.clientLogin';
    AppStates.root_core_resolveLink = AppStates.root_core + '.resolveLink';
    AppStates.root_core_universalLink = AppStates.root_core + '.universalLink';

    AppStates.root_core_receipt = AppStates.root_core + '.receipt';

    AppStates.root_core_questionnaireSubmitted = AppStates.root_core + '.questionnaireSubmitted';

    AppStates.root_core_setPassword = AppStates.root_core + '.setPassword';
    AppStates.root_core_resetPassword = AppStates.root_core + '.resetPassword';
    AppStates.root_core_resetPasswordForEvent = AppStates.root_core + '.resetPasswordForEvent';
    AppStates.root_core_resetPasswordForWorkspace = AppStates.root_core + '.resetPasswordForWorkspace';
    AppStates.root_core_resetPasswordForFile = AppStates.root_core + '.resetPasswordForFile';
    AppStates.root_core_resetPasswordForExternalSite = AppStates.root_core + '.resetPasswordForExternalSite';
    AppStates.root_core_resetPasswordForNetwork = AppStates.root_core + '.resetPasswordForNetwork';
    AppStates.root_core_resetPasswordForNetworkProject = AppStates.root_core + '.resetPasswordForNetworkProject';
    AppStates.root_core_resetPasswordForNetworkProfile = AppStates.root_core + '.resetPasswordForNetworkProfile';

    AppStates.root_core_admin = AppStates.root_core + '.admin';
    AppStates.root_core_admin_login = AppStates.root_core_admin + '.login';

    //Google integration
    AppStates.root_core_googleOAuth2Callback = AppStates.root_core + '.googleOAuth2Callback';

    AppStates.root_core_navigation_account = AppStates.root_core_navigation + '.account';
    AppStates.root_core_navigation_accountMobile = AppStates.root_core_navigation + '.accountMobile';

    AppStates.root_core_navigation_creatives = AppStates.root_core_navigation + '.creatives';


    AppStates.root_core_navigation_onboardingSetupGuide = AppStates.root_core_navigation + '.onboardingSetupGuide';
    AppStates.root_core_navigation_yearInReview = AppStates.root_core + '.yearInReview';

    AppStates.root_core_navigation_brands = AppStates.root_core_navigation + '.brands';

    ///////////////////////////
    //     Malkut states     //
    ///////////////////////////
    AppStates.root_malkut = AppStates.root + '.malkut';
    AppStates.root_malkut_dashboard = AppStates.root_malkut + '.dashboard';
    AppStates.root_malkut_sales = AppStates.root_malkut + '.sales';
    AppStates.root_malkut_pricing = AppStates.root_malkut + '.pricing';
    AppStates.root_malkut_rts = AppStates.root_malkut + '.rts';
    AppStates.root_malkut_referrals = AppStates.root_malkut + '.referrals';
    AppStates.root_malkut_referrals_commissions = AppStates.root_malkut_referrals + '.commissions';
    AppStates.root_malkut_referrals_campaigns = AppStates.root_malkut_referrals + '.campaigns';
    AppStates.root_malkut_referrals_user = AppStates.root_malkut_referrals + '.user';
    AppStates.root_malkut_referrals_user_search = AppStates.root_malkut_referrals_user + '.search';
    AppStates.root_malkut_referrals_user_result = AppStates.root_malkut_referrals_user + '.result';
    AppStates.root_malkut_cs = AppStates.root_malkut + '.cs';
    AppStates.root_malkut_loans = AppStates.root_malkut + '.loans';
    AppStates.root_malkut_cs_companies = AppStates.root_malkut_cs + '.companies';
    AppStates.root_malkut_cs_contacts = AppStates.root_malkut_cs + '.contacts';
    AppStates.root_malkut_cs_userDetails = AppStates.root_malkut_cs + '.user_details';
    AppStates.root_malkut_cs_contactForm = AppStates.root_malkut_cs + '.contact_form';
    AppStates.root_malkut_cs_usersBounced = AppStates.root_malkut_cs + '.users_bounced';
    AppStates.root_malkut_cs_inboundMessages= AppStates.root_malkut_cs + '.inbound_messages';
    AppStates.root_malkut_cs_globalSearch = AppStates.root_malkut_cs + '.global_search';
    AppStates.root_malkut_cs_generalTasks = AppStates.root_malkut_cs + '.general_tasks';
    AppStates.root_malkut_cs_userDetails_search = AppStates.root_malkut_cs_userDetails + '.search';
    AppStates.root_malkut_cs_userDetails_result = AppStates.root_malkut_cs_userDetails + '.result';
    AppStates.root_malkut_trends = AppStates.root_malkut + '.trends';
    AppStates.root_malkut_successful_transfers = AppStates.root_malkut + '.successful_transfers';
    AppStates.root_malkut_failed_transfers = AppStates.root_malkut + '.failed_transfers';
    AppStates.root_malkut_unverified_recipients = AppStates.root_malkut + '.unverified_recipients';
    AppStates.root_malkut_managed_accounts = AppStates.root_malkut + '.managed_accounts';
    AppStates.root_malkut_blocked_vendors = AppStates.root_malkut + '.blocked_vendors';
    AppStates.root_malkut_unverified_objects = AppStates.root_malkut + '.unverified_objects';
    AppStates.root_malkut_graph = AppStates.root_malkut + '.graph';
    AppStates.root_malkut_disputed_payments = AppStates.root_malkut + '.disputed_payments';
    AppStates.root_malkut_administration = AppStates.root_malkut + '.administration';
    AppStates.root_malkut_cs_searchSfdc = AppStates.root_malkut_cs + '.search_sfdc';


    ////////////////////////
    // Network states     //
    ////////////////////////
    AppStates.root_network = AppStates.root + '.network';
    AppStates.root_network_navigation = AppStates.root_network + '.navigation';

    AppStates.root_network_my_profile = AppStates.root_network_navigation + '.my_profile';
    AppStates.root_network_profile = AppStates.root_network_navigation + '.profile';
    AppStates.root_network_edit_profile = AppStates.root_network_navigation + '.edit_profile';
    AppStates.root_network_project = AppStates.root_network_navigation + '.project';
    AppStates.root_network_create_project = AppStates.root_network_navigation + '.create_project';
    AppStates.root_network_edit_project = AppStates.root_network_navigation + '.edit_project';


    AppStates.root_network_feed = AppStates.root_network_navigation + '.feed';
    AppStates.root_network_feed_projects = AppStates.root_network_navigation + '.feed_projects';
    AppStates.root_network_opportunities = AppStates.root_network_navigation + '.opportunities';
    AppStates.root_network_myopportunities = AppStates.root_network_navigation + '.my_opportunities';
    AppStates.root_network_moderation = AppStates.root_network_navigation + '.moderation';
    AppStates.root_network_settings_email = AppStates.root_network_navigation + '.settings_email';
    AppStates.root_network_settings = AppStates.root_network_navigation + '.settings';

}]);
